import PrintJob, { CancelationReasons, JobStatuses } from '../../../types/api/print-job'

export enum PrintStatusDisplay {
    InDistribution = 'В распределении',
    InMachineQueue = 'В очереди на станке',
    InProgress = 'В работе',
    Completed = 'Завершено',
    Cancelled = 'Отменено',
}

export function getPrintStatusDisplay(jobStatus?: JobStatuses): PrintStatusDisplay | null {
    if (!jobStatus) return null

    switch (jobStatus) {
        case JobStatuses.Created:
            return PrintStatusDisplay.InDistribution
        case JobStatuses.Planned:
        case JobStatuses.Preparing:
        case JobStatuses.Prepared:
            return PrintStatusDisplay.InMachineQueue
        case JobStatuses.Printing:
            return PrintStatusDisplay.InProgress
        case JobStatuses.Completed:
            return PrintStatusDisplay.Completed
        case JobStatuses.Cancelled:
            return PrintStatusDisplay.Cancelled
        default:
            return null
    }
}

export function getPrintStatusTooltip(
    displayStatus: PrintStatusDisplay,
    printJob?: PrintJob
): string {
    if (displayStatus !== PrintStatusDisplay.Cancelled || !printJob) {
        return displayStatus
    }

    const reason =
        printJob.cancelationReason === CancelationReasons.Other
            ? printJob.otherCancelationReason
            : printJob.cancelationReason

    return reason ? `${displayStatus}: ${reason}` : displayStatus
}
